import Icon from "@/components/icon";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type LargeVoiceProps = {
  article: Content.Article;
  largeHeader?: boolean;
};

const LargeVoice = (props: LargeVoiceProps) => {
  const category = props.article.fields.categories?.[0];
  const author = props.article.fields.authors?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;
  const hideBylineImage = props.article.fields.hideBylineImage;

  const parentCategory = category?.fields.parentCategory;
  const color = category?.fields.color || parentCategory?.fields.color;

  return (
    <Link
      href={`/${props.article.fields.slug}`}
      className="relative bg-sand-600 group flex flex-col sm:flex-row items-center justify-between text-gray-500  py-0 overflow-hidden md:max-h-[381px]"
    >
      <div className="flex flex-col md:w-[calc(100%-250px)] w-full p-8">
        <Icon.Quote className="text-sand-800 fill-sand-800 absolute top-8 lg:top-12 -z-1 w-[80px]" />

        {title && (
          <TeaserHeading
            text={title}
            className="text-4xl lg:text-5xl text-center z-2 relative mt-12 md:mt-16 font-semibold"
          />
        )}

        {author?.fields.name && (
          <div className="font-brush text-3xl mt-4 sm:mt-16 text-center">
            {author.fields.name}
          </div>
        )}
      </div>

      {author?.fields.image?.fields.file?.url && (
        <div className="lg:absolute lg:bottom-0 lg:right-0 w-[250px] h-[250px] mt-auto overflow-hidden">
          <Image
            src={createImageUrl(author?.fields.image?.fields.file?.url, {
              crop: "1:1",
            })}
            alt=""
            width={250}
            height={250}
            className="object-contain md:object-right-bottom"
          />
        </div>
      )}
    </Link>
  );
};

export default LargeVoice;
